import { connect } from 'react-redux'
import { dateSortedCommentsListSelector } from '@selectors/data/comment_selectors.js'
import {
  getSelectedCommentIds,
  getAwaitingBulkShowAsyncResponse,
  getAwaitingBulkHideAsyncResponse,
} from '../reducers/index.js'
import {
  changeCommentSelection,
  selectAllComments,
  deselectAllComments,
  selectVisible,
  selectHidden,
} from '../actions/comment_moderation_actions.js'
import { bulkChangeCommentsVisibility } from '../actions/bulk_comment_actions.js'
import CommentModeration from '../components/comment_moderation.jsx'

const mapStateToProps = (state, props) => {
  const selectedCommentIds = getSelectedCommentIds(state, props)
  const comments = dateSortedCommentsListSelector(state, props)
  const awaitingBulkShowAsyncResponse = getAwaitingBulkShowAsyncResponse(state)
  const awaitingBulkHideAsyncResponse = getAwaitingBulkHideAsyncResponse(state)
  return {
    selectedCommentIds,
    comments,
    awaitingBulkShowAsyncResponse,
    awaitingBulkHideAsyncResponse,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSelectionChange: function (commentId, selected) {
      dispatch(changeCommentSelection(commentId, selected))
    },
    onSelectAll: function (comments) {
      dispatch(selectAllComments(comments))
    },
    onDeselectAll: function (comments) {
      dispatch(deselectAllComments(comments))
    },
    onSelectVisible: function (comments) {
      dispatch(selectVisible(comments))
    },
    onSelectHidden: function (comments) {
      dispatch(selectHidden(comments))
    },
    onShowSelected: function (ids) {
      dispatch(bulkChangeCommentsVisibility(ids, true))
    },
    onHideSelected: function (ids) {
      dispatch(bulkChangeCommentsVisibility(ids, false))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentModeration)
